import {
  init,
  browserTracingIntegration,
  replayIntegration,
} from '@sentry/vue';
import type { App } from 'vue';
import type { Router } from 'vue-router';

export function bootSentry({ app, router }: { app: App; router: Router }) {
  init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [browserTracingIntegration({ router }), replayIntegration()],
    tracesSampleRate: 0.5,
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/(.*\.)?tamanager\.de(\/api)?/,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
